import { Flex, InfiniteScroll, Loading } from '@shared/components';

import { ItemSetQuestionInLocation, NoQuestionInLocationOverlay } from '../../components';
import type { Question } from '../../types';

interface ItemSetQuestionsInLocationListProps {
  itemSetQuestions: Question[];
  loading: boolean;
  hasMore: boolean;
  handleFetchMore: () => Promise<void>;
  structureId: string;
  currentPage: number;
  currentItemSetId?: string;
}

export default function ItemSetQuestionsInLocationList(
  props: Readonly<ItemSetQuestionsInLocationListProps>,
) {
  const {
    itemSetQuestions,
    loading: isLoading,
    hasMore,
    handleFetchMore: fetchMore,
    structureId,
    currentPage,
    currentItemSetId,
  } = props;

  const handleFetchMore = async () => {
    await fetchMore();
  };

  if (isLoading && !itemSetQuestions.length) {
    return <Loading />;
  }

  if (!itemSetQuestions.length) {
    return <NoQuestionInLocationOverlay variant='no-question' />;
  }

  return (
    <InfiniteScroll
      hasMore={hasMore}
      handleFetch={handleFetchMore}
      loading={isLoading}
      loader={<Loading />}
      maxHeight={currentPage === 0 && !hasMore ? 'fit-content' : '384px'}
    >
      <Flex sx={(theme) => ({ flexDirection: 'column', rowGap: theme.spacing(2.5) })}>
        {itemSetQuestions.map((itemSetQuestion) => {
          return (
            <ItemSetQuestionInLocation
              question={itemSetQuestion}
              key={itemSetQuestion.id}
              structureId={structureId}
              highlight={itemSetQuestion.id === currentItemSetId}
            />
          );
        })}
      </Flex>
    </InfiniteScroll>
  );
}
